import React, { useEffect, useState } from "react";
import "./Analytics.css";
import vectior1 from "../../../../assets/images/fanGroup/Vector.png";
import vectior2 from "../../../../assets/images/fanGroup/Vector (1).png";
import vectior3 from "../../../../assets/images/fanGroup/unknown.png";
import chart from "../../../../assets/images/fanGroup/chart.png";
import fan from "../../../../assets/images/Fanbase-img/1.png";
import { Table } from "react-bootstrap";
import { Chart as ChartJS } from "chart.js/auto";
import { Chart } from "react-chartjs-2";
import { Line } from "react-chartjs-2";
import { useParams } from "react-router-dom";
import axios from "axios";

// const [analytics, setAnalytics] = useState([0, 53, 85, 41, 44, 65]);
// const [analytics, setAnalytics] = useState([0, 53, 85, 41, 44, 65]);

const Analytics = () => {
  const [analytics, setAnalytics] = useState();
  const [anotherAnalytics, setAnotherAnalytics] = useState();
  const [fanDetails, setFanDetails] = useState([]);
  const [myStarPost, setFanPostMyStar] = useState();
  const [anotherStarPost, setFanPostAnotherStar] = useState();

  // map = Object.keys(analytics).map(item => `${analytics[item]}`)

  let { slug } = useParams();

  // const [myStarA, setMyStarAnalytics] = useState([]);

  useEffect(() => {
    axios.get(`/api/admin/fan/group/analytics/${slug}`).then((res) => {
      if (res.status === 200) {
        setAnalytics(res.data.myStarAnalytics);
        setAnotherAnalytics(res.data.anotherStarAnalytics);
        setFanDetails(res.data.fanDetails);
        setFanPostMyStar(res.data.myStarPost);
        setFanPostAnotherStar(res.data.anotherStarPost);
      }
    });
  }, [slug]);

  const data = {
    labels: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    bezierCurve: false,
    datasets: [
      {
        label: "dataset",
        data: analytics,
        fill: true,
        // backgroundColor: "#7E1D9C",
        borderColor: "#FEF40B",
      },
      {
        label: "Second dataset",
        data: anotherAnalytics,
        fill: true,
        borderColor: "#742774",
      },
    ],
  };

  const legend = {
    display: true,
    position: "bottom",
    labels: {
      fontColor: "#323130",
      fontSize: 14,
    },
  };

  const options = {
    title: {
      display: true,
      text: "Chart Title",
    },
    scales: {
      yAxes: [
        {
          ticks: {
            suggestedMin: 0,
            suggestedMax: 100,
          },
        },
      ],
    },
  };

  return (
    <div className="container my-3">
      <div className="row">
        <div className="col-md-6">
          <div className="card card-bg mb-2">
            <div className="card-body">
              <div className="d-flex ">
                <div className="fanGroupicon  d-flex align-items-center">
                  <i className="fa-solid fa-user-group fan-icon"></i>
                </div>
                <div className="graph-content w-50 mx-3">
                  <small className="text-light m-0 p-0">
                    {" "}
                    {fanDetails.my_superstar?.first_name}{" "}
                    {fanDetails.my_superstar?.last_name} FanPost
                  </small>
                  <h2 className="text-light m-0 p-0">{myStarPost}</h2>
                </div>
                <div>
                  <img src={vectior1} alt="" className="img-fluid" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="card card-bg">
            <div className="card-body">
              <div className="d-flex ">
                <div className="fanGroupicon  d-flex align-items-center">
                  <i className="fa-solid fa-user-group fan-icon2"></i>
                </div>
                <div className="graph-content w-50 mx-3">
                  <small className="text-light m-0 p-0">
                    {fanDetails.another_superstar?.first_name}{" "}
                    {fanDetails.another_superstar?.last_name} FanPost
                  </small>
                  <h2 className="text-light m-0 p-0">{anotherStarPost}</h2>
                </div>
                <div>
                  <img src={vectior2} alt="" className="img-fluid" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row my-3">
        <div className="container-lg">
          <div className="card " style={{ border: "none" }}>
            {/* <img src={chart} className="img-fluid w-100 " alt="" /> */}
            <Line data={data} legend={legend} options={options} />
          </div>
        </div>
      </div>

      {/* <div className="row my-3">
    <div className="container-fluid">
      <div className="card card-bg">
        <div className="card-body">
          <h5 className="text-light">Members List</h5>

          <Table striped bordered hover variant="dark" style={{ fontSize:'12px' }}>
            <thead>
              <tr>
                <th>Members Name</th>
                <th>Post</th>
                <th>Reactions</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><img src={vectior3} className='img-fluid mx-1' alt="" /> Shoyib Mallick</td>
                <td>24 <i className="fa-solid fa-arrow-down text-danger mx-1"></i><span className="text-danger">21</span>
                </td>
                <td>240 <i className="fa-solid fa-arrow-down text-danger mx-1"></i><span className="text-danger">21</span>
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
      </div>
    </div>
  </div> */}
    </div>
  );
};

export default Analytics;
